import { apiRaw, apiRequest } from './api';
import {
  EXPIRING_PAGE_SIZE,
  expiringPageFromEnvelope,
  expiringQueryString,
  type ExpiringCounts,
  type ExpiringDivision,
  type ExpiringEnvelope,
  type ExpiringFilters,
  type ExpiringPageResult,
} from './expiring-shape';

/** «Próximos vencimientos» — `GET /results/expiring` (Spain only; 404 elsewhere). */
export async function fetchExpiring(f: ExpiringFilters): Promise<ExpiringPageResult> {
  const qs = expiringQueryString(f, {
    limit: EXPIRING_PAGE_SIZE,
    offset: (f.page - 1) * EXPIRING_PAGE_SIZE,
  });
  return expiringPageFromEnvelope(await apiRaw<ExpiringEnvelope>(`/results/expiring?${qs}`));
}

export async function fetchExpiringCounts(
  f: Pick<ExpiringFilters, 'cpv' | 'region' | 'buyer' | 'q'> = {},
): Promise<ExpiringCounts> {
  const qs = expiringQueryString(f);
  return apiRequest<ExpiringCounts>(`/results/expiring/counts${qs ? `?${qs}` : ''}`);
}

export async function fetchExpiringDivisions(f: ExpiringFilters): Promise<ExpiringDivision[]> {
  const qs = expiringQueryString({ ...f, cpv: undefined });
  return (await apiRequest<ExpiringDivision[]>(`/results/expiring/divisions?${qs}`)) ?? [];
}
